// extracted by mini-css-extract-plugin
module.exports = {"wrap":"BcOpm","theme_horizontal":"Ia0ev"};